"use client"

import { Bot, Zap, Wrench } from "lucide-react"
import type { CommunityPost } from "@/lib/community/types"

interface AgentShowcaseProps {
  capabilities?: string[]
  agentDetail?: CommunityPost["agentDetail"]
}

export function AgentShowcase({ capabilities, agentDetail }: AgentShowcaseProps) {
  if (!agentDetail && (!capabilities || capabilities.length === 0)) return null

  return (
    <div className="mb-5 space-y-2 w-fit">
      <h4 className="text-xs font-semibold text-muted-foreground uppercase tracking-wider flex items-center gap-1.5">
        <Bot className="h-3.5 w-3.5 text-blue-700" />
        智能体详情
      </h4>

      <div className="rounded-xl border border-blue-700/15 overflow-hidden">
        {agentDetail && (
          <div className="px-4 py-3">
            {/* Role badge + stats */}
            <div className="flex items-center gap-2 mb-2">
              <span className="text-micro font-medium text-foreground">
                {agentDetail.role}
              </span>
              <div className="flex items-center gap-2 text-micro text-muted-foreground">
                <span className="flex items-center gap-0.5">
                  <Zap className="h-3 w-3" />
                  {agentDetail.skillNames.length} 技能
                </span>
                <span className="flex items-center gap-0.5">
                  <Wrench className="h-3 w-3" />
                  {agentDetail.toolCount} 工具
                </span>
              </div>
            </div>

            {/* Description */}
            {agentDetail.description && (
              <p className="text-caption text-foreground/70 leading-relaxed mb-2.5">
                {agentDetail.description}
              </p>
            )}

            {/* Skill names */}
            {agentDetail.skillNames.length > 0 && (
              <div className="flex flex-wrap gap-1">
                {agentDetail.skillNames.map((skill) => (
                  <span
                    key={skill}
                    className="text-micro px-1.5 py-0.5 rounded-md bg-blue-700/10 text-blue-700/70 dark:text-blue-400/60 border border-blue-700/15"
                  >
                    {skill}
                  </span>
                ))}
              </div>
            )}
          </div>
        )}

        {/* Capability badges (always show if present) */}
        {capabilities && capabilities.length > 0 && (
          <div className={`px-4 py-3 ${agentDetail ? "border-t border-blue-700/10" : ""}`}>
            <p className="text-micro text-muted-foreground mb-1.5">能力标签</p>
            <div className="flex flex-wrap gap-1.5">
              {capabilities.map((cap) => (
                <span
                  key={cap}
                  className="text-caption px-2 py-0.5 rounded-full bg-blue-700/10 text-blue-700"
                >
                  {cap}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
